import {
    type OfferRequestBuildingType,
    offerRequestReportStatusSchema,
    OfferRequestProjectSize as projectSize,
} from '@houzy/schemas/offer-request-management';
import {
    offerRequestSortKeySchema,
    type OfferRequestSortKey as SharedOfferRequestSortKey,
    PARTNER_COCKPIT_OFFER_REQUEST_FILTER_CREDIT_OPTIONS,
    partnerCockpitOfferRequestLanguageSchema,
} from '@houzy/schemas/partner-cockpit/offer-requests';
import {
    engagementContactRequestTypeSchema,
    type EngagementContactRequestType,
} from '@houzy/schemas/partner-cockpit/partner-matching';

import type { OfferRequestTimingGroup } from './timing';

const language = partnerCockpitOfferRequestLanguageSchema.enum;
export type OfferRequestLanguage = (typeof language)[keyof typeof language];
export const OfferRequestLanguage = {
    De: language['de-CH'],
    En: language['en-CH'],
    Fr: language['fr-CH'],
    It: language['it-CH'],
} as const;

export const OfferRequestStatus = offerRequestReportStatusSchema.enum;
export type OfferRequestStatus = (typeof OfferRequestStatus)[keyof typeof OfferRequestStatus];

export const OfferRequestCredits = PARTNER_COCKPIT_OFFER_REQUEST_FILTER_CREDIT_OPTIONS;
export type OfferRequestCredits = (typeof OfferRequestCredits)[number];

export type OfferRequestProjectSize = (typeof projectSize)[keyof typeof projectSize];
export const OfferRequestProjectSize = {
    Under5k: projectSize.under_5k,
    From5kTo10k: projectSize.from_5k_to_10k,
    From10kTo20k: projectSize.from_10k_to_20k,
    From20kTo50k: projectSize.from_20k_to_50k,
    Over50k: projectSize.over_50k,
} as const;

const sortKey = offerRequestSortKeySchema.enum;
export type OfferRequestSortKey = SharedOfferRequestSortKey;
export const OfferRequestSortKey = {
    Newest: sortKey.newest,
    Oldest: sortKey.oldest,
} as const;

export type OfferRequestFiltersValue = {
    search: string;
    dateFrom?: string;
    dateTo?: string;
    timingGroups: OfferRequestTimingGroup[];
    projectSizes: OfferRequestProjectSize[];
    credits: OfferRequestCredits[];
    languages: OfferRequestLanguage[];
    buildingTypes: OfferRequestBuildingType[];
    statuses: OfferRequestStatus[];
};

// Default "show everything" state, also used to reset filters via "Clear all".
export const EMPTY_OFFER_REQUEST_FILTERS: OfferRequestFiltersValue = {
    search: '',
    dateFrom: undefined,
    dateTo: undefined,
    timingGroups: [],
    projectSizes: [],
    credits: [],
    languages: [],
    buildingTypes: [],
    statuses: [],
};

export const OfferRequestContactOptions = engagementContactRequestTypeSchema.options;
export type OfferRequestContactOption = EngagementContactRequestType;

export type ContactRequestValue = {
    netPrice: string;
    vatRate: string;
    grossPrice: string;
    message: string;
};
